import React, { useEffect, useState } from "react";
import axios from "axios";
import WorkerSidebar from "../components/WorkerSidebar";

const Inbox = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const workerId = localStorage.getItem("workerId");

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = await axios.get(`http://localhost:5000/api/worker/notifications/${workerId}`);
        setNotifications(res.data || []);
      } catch (err) {
        console.error("Error loading notifications:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, [workerId]);

  return (
    <div className="flex min-h-screen bg-gray-100">
      <WorkerSidebar />
      <div className="flex-1 p-6 ml-0 md:ml-60">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">📩 Inbox</h1>

        {loading ? (
          <p className="text-gray-600">Loading notifications...</p>
        ) : notifications.length === 0 ? (
          <div className="text-center text-gray-500 mt-12 text-lg">No new notifications.</div>
        ) : (
          <div className="space-y-4">
            {notifications.map((note, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow border-l-4 border-blue-500 p-4 hover:shadow-md transition"
              >
                <p className="font-medium text-gray-800">{note.title}</p>
                <p className="text-sm text-gray-600 mt-1">{note.message}</p>
                <p className="text-xs text-gray-400 mt-2">
                  {new Date(note.createdAt).toLocaleString()}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Inbox;
